<template>
  <div class="panel-body">
    <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
    
      <!-- Sección de la tabla -->
    <div v-if="mostrarTabla">
      <b-row class="mb-3" style="margin-top: 100px;">
        <b-col md="3" v-if="!idProveedor">
          <b-form-group label="Filtrar por Proveedor" label-for="filtro-proveedor">
            <b-form-select 
              id="filtro-proveedor"
              v-model="filtroProveedor" 
              @change="aplicarFiltros">
              <option value="">Todos los proveedores</option>
              <option v-for="proveedor in listaProveedores" :key="proveedor.id" :value="proveedor.id">
                {{ proveedor.name }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col :md="idProveedor ? '4' : '3'">
          <b-form-group label="Filtrar por Regional" label-for="filtro-regional">
            <b-form-select 
              id="filtro-regional"
              v-model="filtroRegional" 
              @change="aplicarFiltros">
              <option value="">Todas las regionales</option>
                <option value="ANTIOQUIA - OTROS MUNICIPIOS">ANTIOQUIA - OTROS MUNICIPIOS</option>
                <option value="ANTIOQUIA- URABA">ANTIOQUIA- URABA</option>
                <option value="ANTIOQUIA- AREA METROPOLITANA">ANTIOQUIA- AREA METROPOLITANA</option>
                <option value="ANTIOQUIA- ORIENTE">ANTIOQUIA- ORIENTE</option>
                <option value="NORTE">NORTE</option>
                <option value="CENTRO">CENTRO</option>
                <option value="EJE CAFETERO">EJE CAFETERO</option>
                <option value="OCCIDENTE">OCCIDENTE</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col :md="idProveedor ? '4' : '3'">
          <b-form-group label="Filtrar por Sede" label-for="filtro-sede">
            <b-form-input 
              id="filtro-sede"
              v-model="filtroSede" 
              placeholder="Buscar por sede..."
              @input="aplicarFiltros">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      
      <b-row class="mb-3">
        <b-col md="12" class="d-flex justify-content-end">
          <b-button @click="descargarPlantilla()" variant="info" class="mr-2" :disabled="cargandoExcel">
            <b-icon icon="download" aria-hidden="true"></b-icon>
            Descargar Plantilla
          </b-button>
          <b-button @click="$refs.fileInput.click()" variant="success" class="mr-2" :disabled="cargandoExcel">
            <b-spinner small v-if="cargandoExcel" class="mr-1"></b-spinner>
            <b-icon v-else icon="upload" aria-hidden="true"></b-icon>
            {{ cargandoExcel ? 'Procesando...' : 'Cargar Excel' }}
          </b-button>
          <b-button @click="nuevo()" variant="primary" :disabled="cargandoExcel">
            <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
            Nueva Disponibilidad
          </b-button>
          <input 
            ref="fileInput" 
            type="file" 
            accept=".csv,.xlsx,.xls" 
            style="display: none" 
            @change="cargarArchivoExcel"
            :disabled="cargandoExcel" />
        </b-col>
      </b-row>
      
      <!-- Overlay de carga -->
      <b-overlay :show="cargandoExcel" rounded="sm" variant="white" opacity="0.85" blur="2px">
        <template #overlay>
          <div class="text-center p-4">
            <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
            <p class="mt-3 mb-0"><strong>Procesando archivo Excel...</strong></p>
            <small class="text-muted">Por favor espere</small>
          </div>
        </template>
      
      <b-table 
        responsive 
        id="my-tablems"
        head-variant="light" 
        striped 
        :per-page="perPage" 
        :current-page="currentPage" 
        :items="items" 
        :fields="fields"
        :busy="esperandoInfo">
        
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle" variant="primary"></b-spinner>
            <strong class="ml-2">Cargando...</strong>
          </div>
        </template>

        <template #cell(fecha)="row">
          <span>{{ formatearFecha(row.item.fecha) }}</span>
        </template>

        <template #cell(Acciones)="row">
          <b-row class="acciones">
            <b-col>
              <b-button 
                id="tooltip-target-ver" 
                variant="primary"
                @click="verDisponibilidad(row.item)">
                <b-icon class="iconobuscar" icon="eye-fill" />
              </b-button>
              <b-tooltip target="tooltip-target-ver" triggers="hover" placement="right">
                Ver más
              </b-tooltip>
            </b-col>
            <b-col>
              <b-button 
                id="tooltip-target-editar" 
                variant="info"
                @click="editarDisponibilidad(row.item)">
                <b-icon class="iconobuscar" icon="pencil-square" />
              </b-button>
              <b-tooltip target="tooltip-target-editar" triggers="hover">
                Editar
              </b-tooltip>
            </b-col>
          </b-row>
        </template>
      </b-table>
      
      <div class="spinerr" v-if="esperandoInfo == true">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
      
      <div class="divnodata" v-if="items.length == 0 && esperandoInfo != true">
        <b-img class="bannernodata" src="/img/banner.jpg"></b-img>
        <p>No se encontró información</p>
      </div>
      
      <b-row>
        <b-col class="nombrelabel" md="2" offset-md="9">
          <label for="selectPage">Registros por página:</label>
        </b-col>
        <b-col md="1">
          <b-form-select 
            class="selectpage" 
            @input="paginacion(currentPage = 1)" 
            v-model="perPage"
            :options="pageOptions" />
        </b-col>
      </b-row>
      
      <b-pagination 
        class="justify-content-center" 
        v-model="currentPage" 
        :total-rows="rows" 
        :per-page="perPage"
        @input="paginacion(currentPage)" 
        aria-controls="my-tablems">
      </b-pagination>
      </b-overlay>
    </div>

    <!-- Sección del formulario -->
    <div v-if="mostrarFormulario">
      <b-row class="mb-3">
        <b-col>
          <b-button variant="secondary" @click="volverATabla()">
            <b-icon icon="arrow-left"></b-icon> Volver
          </b-button>
        </b-col>
      </b-row>
      
      <b-card>
        <template #header>
          <h4 class="mb-0">
            <span v-if="modoFormulario === 'crear'">Registrar Nueva Disponibilidad de Equipos</span>
            <span v-else-if="modoFormulario === 'editar'">Editar Disponibilidad de Equipos</span>
            <span v-else>Ver Disponibilidad de Equipos</span>
          </h4>
        </template>
        
        <b-form @submit.prevent="guardarDisponibilidad">
          <!-- Información General -->
          <h5 class="text-primary mb-3">
            <b-icon icon="info-circle"></b-icon> Información General
          </h5>
          
          <b-row>
            <b-col md="4">
              <b-form-group label="Fecha *" label-for="fecha">
                <b-form-datepicker 
                  id="fecha"
                  v-model="formData.fecha" 
                  :disabled="modoFormulario === 'ver'"
                  locale="es"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  required>
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            
            <b-col md="4">
              <b-form-group label="Regional *" label-for="regional">
                <b-form-select 
                  id="regional"
                  v-model="formData.regional" 
                  :disabled="modoFormulario === 'ver'"
                  required>
                  <option value="">Seleccione...</option>
                  <option value="ANTIOQUIA - OTROS MUNICIPIOS">ANTIOQUIA - OTROS MUNICIPIOS</option>
                <option value="ANTIOQUIA- URABA">ANTIOQUIA- URABA</option>
                <option value="ANTIOQUIA- AREA METROPOLITANA">ANTIOQUIA- AREA METROPOLITANA</option>
                <option value="ANTIOQUIA- ORIENTE">ANTIOQUIA- ORIENTE</option>
                <option value="NORTE">NORTE</option>
                <option value="CENTRO">CENTRO</option>
                <option value="EJE CAFETERO">EJE CAFETERO</option>
                <option value="OCCIDENTE">OCCIDENTE</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            
            <b-col md="4">
              <b-form-group label="Sede de Equipos *" label-for="sede">
                <b-form-input 
                  id="sede"
                  v-model="formData.sede_de_equipos" 
                  :disabled="modoFormulario === 'ver'"
                  placeholder="Ej: Sede Principal"
                  required>
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="12">
              <b-form-group label="Observaciones" label-for="observacion">
                <b-form-textarea 
                  id="observacion"
                  v-model="formData.observacion" 
                  :disabled="modoFormulario === 'ver'"
                  placeholder="Observaciones generales sobre la disponibilidad..."
                  rows="3">
                </b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>

          <hr class="my-4">

          <!-- Concentradores -->
          <h5 class="text-primary mb-3">
            <b-icon icon="cpu"></b-icon> Concentradores
          </h5>
          
          <b-row>
            <b-col md="6">
              <b-card bg-variant="light" class="mb-3">
                <template #header>
                  <strong>Concentrador Bajo Flujo</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Día *" label-for="conc_bajo_flujo_dia">
                      <b-form-input 
                        id="conc_bajo_flujo_dia"
                        v-model="formData.conc_bajo_flujo_dia" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Noche *" label-for="conc_bajo_flujo_noche">
                      <b-form-input 
                        id="conc_bajo_flujo_noche"
                        v-model="formData.conc_bajo_flujo_noche" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col md="6">
              <b-card bg-variant="light" class="mb-3">
                <template #header>
                  <strong>Concentrador Alto Flujo</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Día *" label-for="conc_alto_flujo_dia">
                      <b-form-input 
                        id="conc_alto_flujo_dia"
                        v-model="formData.conc_alto_flujo_dia" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Noche *" label-for="conc_alto_flujo_noche">
                      <b-form-input 
                        id="conc_alto_flujo_noche"
                        v-model="formData.conc_alto_flujo_noche" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col md="6">
              <b-card bg-variant="light" class="mb-3">
                <template #header>
                  <strong>Concentrador Portátil</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Día *" label-for="conc_portatil_dia">
                      <b-form-input 
                        id="conc_portatil_dia"
                        v-model="formData.conc_portatil_dia" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Noche *" label-for="conc_portatil_noche">
                      <b-form-input 
                        id="conc_portatil_noche"
                        v-model="formData.conc_portatil_noche" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <hr class="my-4">

          <!-- Equipos Médicos -->
          <h5 class="text-primary mb-3">
            <b-icon icon="heart-pulse"></b-icon> Equipos Médicos
          </h5>
          
          <b-row>
            <b-col md="6">
              <b-card bg-variant="light" class="mb-3">
                <template #header>
                  <strong>Aspirador</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Día *" label-for="aspirador_dia">
                      <b-form-input 
                        id="aspirador_dia"
                        v-model="formData.aspirador_dia" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Noche *" label-for="aspirador_noche">
                      <b-form-input 
                        id="aspirador_noche"
                        v-model="formData.aspirador_noche" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col md="6">
              <b-card bg-variant="light" class="mb-3">
                <template #header>
                  <strong>Nebulizador</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Día *" label-for="nebulizador_dia">
                      <b-form-input 
                        id="nebulizador_dia"
                        v-model="formData.nebulizador_dia" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Noche *" label-for="nebulizador_noche">
                      <b-form-input 
                        id="nebulizador_noche"
                        v-model="formData.nebulizador_noche" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <hr class="my-4">

          <!-- Oxímetros -->
          <h5 class="text-primary mb-3">
            <b-icon icon="activity"></b-icon> Oxímetros
          </h5>
          
          <b-row>
            <b-col md="6">
              <b-card bg-variant="light" class="mb-3">
                <template #header>
                  <strong>Oxímetro Adulto</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Día *" label-for="oximetro_adul_dia">
                      <b-form-input 
                        id="oximetro_adul_dia"
                        v-model="formData.oximetro_adul_dia" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Noche *" label-for="oximetro_adul_noche">
                      <b-form-input 
                        id="oximetro_adul_noche"
                        v-model="formData.oximetro_adul_noche" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col md="6">
              <b-card bg-variant="light" class="mb-3">
                <template #header>
                  <strong>Oxímetro Pediátrico</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Día *" label-for="oximetro_ped_dia">
                      <b-form-input 
                        id="oximetro_ped_dia"
                        v-model="formData.oximetro_ped_dia" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Noche *" label-for="oximetro_ped_noche">
                      <b-form-input 
                        id="oximetro_ped_noche"
                        v-model="formData.oximetro_ped_noche" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <hr class="my-4">

          <!-- Otros Equipos -->
          <h5 class="text-primary mb-3">
            <b-icon icon="tools"></b-icon> Otros Equipos
          </h5>
          
          <b-row>
            <b-col md="6">
              <b-card bg-variant="light" class="mb-3">
                <template #header>
                  <strong>Bala Portátil</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Día *" label-for="bala_portatil_dia">
                      <b-form-input 
                        id="bala_portatil_dia"
                        v-model="formData.bala_portatil_dia" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Noche *" label-for="bala_portatil_noche">
                      <b-form-input 
                        id="bala_portatil_noche"
                        v-model="formData.bala_portatil_noche" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col md="6">
              <b-card bg-variant="light" class="mb-3">
                <template #header>
                  <strong>Regulador Ahorrador</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Día *" label-for="regulador_ahorrador_dia">
                      <b-form-input 
                        id="regulador_ahorrador_dia"
                        v-model="formData.regulador_ahorrador_dia" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Noche *" label-for="regulador_ahorrador_noche">
                      <b-form-input 
                        id="regulador_ahorrador_noche"
                        v-model="formData.regulador_ahorrador_noche" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col md="6">
              <b-card bg-variant="light" class="mb-3">
                <template #header>
                  <strong>Paquete Pediátrico</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Día *" label-for="paquete_pediatrico_dia">
                      <b-form-input 
                        id="paquete_pediatrico_dia"
                        v-model="formData.paquete_pediatrico_dia" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Noche *" label-for="paquete_pediatrico_noche">
                      <b-form-input 
                        id="paquete_pediatrico_noche"
                        v-model="formData.paquete_pediatrico_noche" 
                        :disabled="modoFormulario === 'ver'"
                        type="number"
                        min="0"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <!-- Resumen de Totales -->
          <b-alert show variant="info" v-if="modoFormulario !== 'ver'">
            <h6 class="mb-2">📊 Resumen Total de Equipos</h6>
            <b-row>
              <b-col md="6">
                <strong>Total Día:</strong> {{ calcularTotalDia() }} equipos
              </b-col>
              <b-col md="6">
                <strong>Total Noche:</strong> {{ calcularTotalNoche() }} equipos
              </b-col>
            </b-row>
            <div class="mt-2">
              <strong>Total General:</strong> {{ calcularTotalGeneral() }} equipos
            </div>
          </b-alert>
          
          <b-row v-if="modoFormulario !== 'ver'">
            <b-col class="text-right">
              <b-button variant="secondary" @click="volverATabla()" class="mr-2">
                Cancelar
              </b-button>
              <b-button 
                variant="primary" 
                type="submit" 
                :disabled="loading">
                <b-spinner v-if="loading" small></b-spinner>
                <span v-else>
                  {{ modoFormulario === 'crear' ? 'Registrar Disponibilidad' : 'Guardar Cambios' }}
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Vue from 'vue'
import HeaderGeneral from "../../components/HeaderGeneral.vue";
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import "vue-form-generator/dist/vfg-core.css";
import * as XLSX from 'xlsx';

Vue.use(VueFormGenerator)

const disponibilidad = RepositoryFactory.get("disponibilidad");
const config = RepositoryFactory.get("config");

export default {
  components: {
    "vue-form-generator": VueFormGenerator.component,
    HeaderGeneral
  },
  data() {
    return {
      vista: "Disponibilidad de Equipos",
      proveniente: " - Gestión de disponibilidad de equipos",
      carpeta: "Proveedores",
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30],
      currentPage: 1,
      esperandoInfo: false,
      items: [],
      totalRows: 0,
      // Filtros
      filtroProveedor: '',
      filtroRegional: '',
      filtroSede: '',
      // ID del proveedor del usuario logueado
      idProveedor: null,
      // Lista de proveedores para el select
      listaProveedores: [],
      fields: [
        { key: 'fecha', label: 'Fecha', sortable: true },
        { key: 'nombre_proveedor', label: 'Proveedor', sortable: true },
        { key: 'regional', label: 'Regional', sortable: true },
        { key: 'sede_de_equipos', label: 'Sede', sortable: true },
        { key: 'total_dia', label: 'Total Día', sortable: true },
        { key: 'total_noche', label: 'Total Noche', sortable: true },
        { key: 'observacion', label: 'Observación', sortable: false },
        'Acciones'
      ],
      // Variables para el formulario
      mostrarFormulario: false,
      mostrarTabla: true,
      modoFormulario: 'crear', // 'crear', 'editar', 'ver'
      disponibilidadActual: {},
      formData: {
        fecha: '',
        proveedor: null,
        regional: '',
        sede_de_equipos: '',
        observacion: '',
        conc_bajo_flujo_dia: 0,
        conc_bajo_flujo_noche: 0,
        conc_alto_flujo_dia: 0,
        conc_alto_flujo_noche: 0,
        conc_portatil_dia: 0,
        conc_portatil_noche: 0,
        aspirador_dia: 0,
        aspirador_noche: 0,
        nebulizador_dia: 0,
        nebulizador_noche: 0,
        oximetro_adul_dia: 0,
        oximetro_adul_noche: 0,
        oximetro_ped_dia: 0,
        oximetro_ped_noche: 0,
        bala_portatil_dia: 0,
        bala_portatil_noche: 0,
        regulador_ahorrador_dia: 0,
        regulador_ahorrador_noche: 0,
        paquete_pediatrico_dia: 0,
        paquete_pediatrico_noche: 0
      },
      loading: false,
      cargandoExcel: false,
      columnasRequeridas: [
        'Fecha',
        'Regional',
        'Sede de Equipos',
        'Observación',
        'Concentrador Bajo Flujo (Día)',
        'Concentrador Bajo Flujo (Noche)',
        'Concentrador Alto Flujo (Día)',
        'Concentrador Alto Flujo (Noche)',
        'Concentrador Portátil (Día)',
        'Concentrador Portátil (Noche)',
        'Aspirador (Día)',
        'Aspirador (Noche)',
        'Nebulizador (Día)',
        'Nebulizador (Noche)',
        'Oxímetro Adulto (Día)',
        'Oxímetro Adulto (Noche)',
        'Oxímetro Pediátrico (Día)',
        'Oxímetro Pediátrico (Noche)',
        'Bala Portátil (Día)',
        'Bala Portátil (Noche)',
        'Regulador Ahorrador (Día)',
        'Regulador Ahorrador (Noche)',
        'Paquete Pediátrico (Día)',
        'Paquete Pediátrico (Noche)'
      ]
    }
  },
  computed: {
    rows() {
      return this.totalRows || this.items.length
    },
  },
  async created() {
    try {
      // Obtener el ID del proveedor del usuario logueado
      const datosUser = localStorage.getItem('user');
      if (datosUser) {
        let datoUserJSON = JSON.parse(datosUser);
        let dato_proveedor = datoUserJSON.id_proveedor;
        
        if (dato_proveedor) {
          this.idProveedor = dato_proveedor;
          this.formData.proveedor = this.idProveedor;
          console.log("Usuario con proveedor asignado:", this.idProveedor);
        } else {
          // Usuario sin proveedor asignado - mostrará todos los registros
          console.log("Usuario sin proveedor asignado - mostrando todos los registros");
          this.$bvToast.toast('Usuario sin proveedor asignado. Mostrando todos los registros.', {
            title: 'Información',
            variant: 'info',
            autoHideDelay: 3000
          });
          
          // Cargar lista de proveedores para el filtro
          await this.cargarListaProveedores();
        }
      } else {
        this.$bvToast.toast('No se pudo obtener la información del usuario', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 3000
        });
      }
      
      // Cargar la lista de disponibilidades
      this.consultarDisponibilidades();
    } catch (error) {
      console.error("Error en created:", error);
      this.$bvToast.toast('Error al cargar la información del usuario', {
        title: 'Error',
        variant: 'danger',
        autoHideDelay: 3000
      });
    }
  },
  methods: {
    async cargarListaProveedores() {
      try {
        const where = [
          {
            "AND": [
              {
                "id": {
                  "iLike": ""
                }
              }
            ]
          }
        ];
        
        const params = {
          nombreEntidad: "entidad_proveedor",
          idVersion: 1,
          column: "id",
          type: "desc",
          size: 1000,
          page: 1,
        };
        
        const response = await config.getMetaData(params, where, []);
        
        if (response && response.message && response.message.rows) {
          this.listaProveedores = response.message.rows.map(item => ({
            id: item.data.id,
            name: item.data.nombre_proveedor
          }));
        }
      } catch (error) {
        console.error("Error cargando proveedores:", error);
        this.listaProveedores = [];
      }
    },
    
    paginacion(currentPage) {
      this.currentPage = currentPage;
      this.consultarDisponibilidades();
    },
    
    nuevo() {
      this.modoFormulario = 'crear';
      this.limpiarFormulario();
      // Establecer la fecha actual por defecto
      const hoy = new Date();
      this.formData.fecha = hoy.toISOString().split('T')[0];
      this.mostrarFormulario = true;
      this.mostrarTabla = false;
    },
    
    async consultarDisponibilidades() {
      try {
        this.esperandoInfo = true;
        
        // Construir filtros en formato where con operadores
        const where = [
          {
            "AND": []
          }
        ];
        
        // Filtrar por proveedor del usuario logueado SOLO si tiene id_proveedor asignado
        // Si NO tiene id_proveedor, traer todos los registros
        if (this.idProveedor) {
          where[0].AND.push({
            "proveedor": {
              "equals": parseInt(this.idProveedor)
            }
          });
        } else {
          // Si no hay proveedor asignado pero hay filtro de proveedor, aplicarlo
          if (this.filtroProveedor) {
            where[0].AND.push({
              "proveedor": {
                "equals": parseInt(this.filtroProveedor)
              }
            });
          } else {
            // Condición: id existe (mayor a 0) para traer todos
            where[0].AND.push({
              "id": {
                "greaterThan": 0
              }
            });
          }
        }
        
        // Aplicar filtro de regional si existe
        if (this.filtroRegional) {
          where[0].AND.push({
            "regional": {
              "iLike": this.filtroRegional
            }
          });
        }
        
        // Aplicar filtro de sede si existe
        if (this.filtroSede) {
          where[0].AND.push({
            "sede_de_equipos": {
              "iLike": `%${this.filtroSede}%`
            }
          });
        }
        
        // Definir relaciones con entidad_proveedor
        const relaciones = [
          {
            "entidad": {
              "nombre": "entidad_proveedor",
              "columna_relacion": "id",
              "columna_relacion_principal": "proveedor",
              "order": {
                "column": "id",
                "type": "asc"
              },
              "size": 5,
              "page": 1,
              "where": [
                {
                  "AND": [
                    {
                      "id": {
                        "iLike": ""
                      }
                    }
                  ]
                }
              ]
            }
          }
        ];
        
        const params = {
          nombreEntidad: "disponibilidad_equipos",
          idVersion: 29,
          column: "id",
          type: "desc",
          size: this.perPage,
          page: this.currentPage,
          orderBy: "id",
          typeOrder: "desc",
        };

        const response = await config.getMetaData(params, where, relaciones);
        
        this.esperandoInfo = false;
        
        if (response && response.message && response.message.rows) {
          this.totalRows = response.message.count || 0;
          this.items = response.message.rows.map((x) => {
            const data = x.data;
            
            // Obtener nombre del proveedor de la relación
            // La estructura es: entidad_proveedor[0][0].d.nombre_proveedor
            const nombreProveedor = data.entidad_proveedor && data.entidad_proveedor[0] && data.entidad_proveedor[0][0] && data.entidad_proveedor[0][0].d
              ? data.entidad_proveedor[0][0].d.nombre_proveedor 
              : `Proveedor ${data.proveedor}`;
            
            // Calcular totales
            const totalDia = parseInt(data.conc_bajo_flujo_dia || 0) + 
                           parseInt(data.conc_alto_flujo_dia || 0) + 
                           parseInt(data.conc_portatil_dia || 0) + 
                           parseInt(data.aspirador_dia || 0) + 
                           parseInt(data.nebulizador_dia || 0) + 
                           parseInt(data.oximetro_adul_dia || 0) + 
                           parseInt(data.oximetro_ped_dia || 0) + 
                           parseInt(data.bala_portatil_dia || 0) + 
                           parseInt(data.regulador_ahorrador_dia || 0) + 
                           parseInt(data.paquete_pediatrico_dia || 0);
            
            const totalNoche = parseInt(data.conc_bajo_flujo_noche || 0) + 
                             parseInt(data.conc_alto_flujo_noche || 0) + 
                             parseInt(data.conc_portatil_noche || 0) + 
                             parseInt(data.aspirador_noche || 0) + 
                             parseInt(data.nebulizador_noche || 0) + 
                             parseInt(data.oximetro_adul_noche || 0) + 
                             parseInt(data.oximetro_ped_noche || 0) + 
                             parseInt(data.bala_portatil_noche || 0) + 
                             parseInt(data.regulador_ahorrador_noche || 0) + 
                             parseInt(data.paquete_pediatrico_noche || 0);
            
            return {
              id: data.id,
              id_metadata: data.id, // Para ediciones
              fecha: data.fecha,
              proveedor: data.proveedor,
              nombre_proveedor: nombreProveedor, // Nombre del proveedor para mostrar en tabla
              regional: data.regional,
              sede_de_equipos: data.sede_de_equipos,
              observacion: data.observacion || '',
              total_dia: totalDia,
              total_noche: totalNoche,
              // Guardar todos los campos para edición
              ...data
            };
          });
        } else {
          this.items = [];
          this.totalRows = 0;
        }
      } catch (error) {
        this.esperandoInfo = false;
        this.items = [];
        this.totalRows = 0;
        console.error("Error consultando disponibilidades:", error);
        this.$bvToast.toast('Error al consultar las disponibilidades', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 3000
        });
      }
    },
    
    aplicarFiltros() {
      this.currentPage = 1;
      this.consultarDisponibilidades();
    },
    
    limpiarFiltros() {
      // Limpiar todos los filtros
      this.filtroProveedor = '';
      this.filtroRegional = '';
      this.filtroSede = '';
      // Recargar datos sin filtros
      this.currentPage = 1;
      this.consultarDisponibilidades();
    },
    
    verDisponibilidad(disponibilidad) {
      this.modoFormulario = 'ver';
      this.cargarDatosFormulario(disponibilidad);
      this.mostrarFormulario = true;
      this.mostrarTabla = false;
    },
    
    editarDisponibilidad(disponibilidad) {
      this.modoFormulario = 'editar';
      this.cargarDatosFormulario(disponibilidad);
      this.mostrarFormulario = true;
      this.mostrarTabla = false;
    },
    
    volverATabla() {
      this.mostrarFormulario = false;
      this.mostrarTabla = true;
      this.limpiarFormulario();
    },
    
    limpiarFormulario() {
      this.formData = {
        fecha: '',
        proveedor: this.idProveedor,
        regional: '',
        sede_de_equipos: '',
        observacion: '',
        conc_bajo_flujo_dia: 0,
        conc_bajo_flujo_noche: 0,
        conc_alto_flujo_dia: 0,
        conc_alto_flujo_noche: 0,
        conc_portatil_dia: 0,
        conc_portatil_noche: 0,
        aspirador_dia: 0,
        aspirador_noche: 0,
        nebulizador_dia: 0,
        nebulizador_noche: 0,
        oximetro_adul_dia: 0,
        oximetro_adul_noche: 0,
        oximetro_ped_dia: 0,
        oximetro_ped_noche: 0,
        bala_portatil_dia: 0,
        bala_portatil_noche: 0,
        regulador_ahorrador_dia: 0,
        regulador_ahorrador_noche: 0,
        paquete_pediatrico_dia: 0,
        paquete_pediatrico_noche: 0
      };
      this.disponibilidadActual = {};
    },
    
    cargarDatosFormulario(disponibilidad) {
      this.disponibilidadActual = { ...disponibilidad };
      this.formData = {
        fecha: disponibilidad.fecha || '',
        proveedor: disponibilidad.proveedor || this.idProveedor,
        regional: disponibilidad.regional || '',
        sede_de_equipos: disponibilidad.sede_de_equipos || '',
        observacion: disponibilidad.observacion || '',
        conc_bajo_flujo_dia: disponibilidad.conc_bajo_flujo_dia || 0,
        conc_bajo_flujo_noche: disponibilidad.conc_bajo_flujo_noche || 0,
        conc_alto_flujo_dia: disponibilidad.conc_alto_flujo_dia || 0,
        conc_alto_flujo_noche: disponibilidad.conc_alto_flujo_noche || 0,
        conc_portatil_dia: disponibilidad.conc_portatil_dia || 0,
        conc_portatil_noche: disponibilidad.conc_portatil_noche || 0,
        aspirador_dia: disponibilidad.aspirador_dia || 0,
        aspirador_noche: disponibilidad.aspirador_noche || 0,
        nebulizador_dia: disponibilidad.nebulizador_dia || 0,
        nebulizador_noche: disponibilidad.nebulizador_noche || 0,
        oximetro_adul_dia: disponibilidad.oximetro_adul_dia || 0,
        oximetro_adul_noche: disponibilidad.oximetro_adul_noche || 0,
        oximetro_ped_dia: disponibilidad.oximetro_ped_dia || 0,
        oximetro_ped_noche: disponibilidad.oximetro_ped_noche || 0,
        bala_portatil_dia: disponibilidad.bala_portatil_dia || 0,
        bala_portatil_noche: disponibilidad.bala_portatil_noche || 0,
        regulador_ahorrador_dia: disponibilidad.regulador_ahorrador_dia || 0,
        regulador_ahorrador_noche: disponibilidad.regulador_ahorrador_noche || 0,
        paquete_pediatrico_dia: disponibilidad.paquete_pediatrico_dia || 0,
        paquete_pediatrico_noche: disponibilidad.paquete_pediatrico_noche || 0
      };
    },
    
    async guardarDisponibilidad() {
      try {
        this.loading = true;
        
        // Si el usuario NO tiene proveedor asignado, solicitar que seleccione uno
        if (!this.formData.proveedor && !this.idProveedor) {
          this.$bvToast.toast('Debe seleccionar o tener asignado un proveedor para guardar', {
            title: 'Advertencia',
            variant: 'warning',
            autoHideDelay: 3000
          });
          this.loading = false;
          return;
        }
        
        // Si el usuario tiene proveedor asignado, usarlo automáticamente
        if (this.idProveedor && !this.formData.proveedor) {
          this.formData.proveedor = this.idProveedor;
        }
        
        if (this.modoFormulario === 'crear') {
          const response = await disponibilidad.guardarDisponibilidadEquipos(this.formData);
          if (response) {
            this.$bvToast.toast('Disponibilidad registrada exitosamente', {
              title: 'Éxito',
              variant: 'success',
              autoHideDelay: 3000
            });
            this.volverATabla();
            this.consultarDisponibilidades();
          } else {
            this.$bvToast.toast('Error al registrar la disponibilidad', {
              title: 'Error',
              variant: 'danger',
              autoHideDelay: 3000
            });
          }
        } else if (this.modoFormulario === 'editar') {
          // Preservar el proveedor original - seguridad: no permitir cambio de proveedor
          const params = {
            ...this.formData,
            proveedor: this.disponibilidadActual.proveedor, // Asegurar que se mantiene el proveedor original
            id_metadata: this.disponibilidadActual.id
          };
          const response = await disponibilidad.editarDisponibilidadEquipos(params);
          if (response) {
            this.$bvToast.toast('Disponibilidad actualizada exitosamente', {
              title: 'Éxito',
              variant: 'success',
              autoHideDelay: 3000
            });
            this.volverATabla();
            this.consultarDisponibilidades();
          } else {
            this.$bvToast.toast('Error al actualizar la disponibilidad', {
              title: 'Error',
              variant: 'danger',
              autoHideDelay: 3000
            });
          }
        }
      } catch (error) {
        console.error('Error guardando disponibilidad:', error);
        this.$bvToast.toast('Error al guardar la disponibilidad', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 3000
        });
      } finally {
        this.loading = false;
      }
    },
    
    formatearFecha(fecha) {
      if (!fecha) return '';
      
      // Si la fecha ya viene en formato YYYY-MM-DD, usarla directamente
      if (typeof fecha === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
        const [anio, mes, dia] = fecha.split('-');
        return `${dia}/${mes}/${anio}`;
      }
      
      // Si viene como objeto Date o timestamp, convertir evitando zona horaria
      try {
        const date = new Date(fecha);
        // Usar UTC para evitar problemas de zona horaria
        const dia = String(date.getUTCDate()).padStart(2, '0');
        const mes = String(date.getUTCMonth() + 1).padStart(2, '0');
        const anio = date.getUTCFullYear();
        return `${dia}/${mes}/${anio}`;
      } catch (error) {
        console.error('Error formateando fecha:', error);
        return fecha;
      }
    },
    
    calcularTotalDia() {
      return parseInt(this.formData.conc_bajo_flujo_dia || 0) + 
             parseInt(this.formData.conc_alto_flujo_dia || 0) + 
             parseInt(this.formData.conc_portatil_dia || 0) + 
             parseInt(this.formData.aspirador_dia || 0) + 
             parseInt(this.formData.nebulizador_dia || 0) + 
             parseInt(this.formData.oximetro_adul_dia || 0) + 
             parseInt(this.formData.oximetro_ped_dia || 0) + 
             parseInt(this.formData.bala_portatil_dia || 0) + 
             parseInt(this.formData.regulador_ahorrador_dia || 0) + 
             parseInt(this.formData.paquete_pediatrico_dia || 0);
    },
    
    calcularTotalNoche() {
      return parseInt(this.formData.conc_bajo_flujo_noche || 0) + 
             parseInt(this.formData.conc_alto_flujo_noche || 0) + 
             parseInt(this.formData.conc_portatil_noche || 0) + 
             parseInt(this.formData.aspirador_noche || 0) + 
             parseInt(this.formData.nebulizador_noche || 0) + 
             parseInt(this.formData.oximetro_adul_noche || 0) + 
             parseInt(this.formData.oximetro_ped_noche || 0) + 
             parseInt(this.formData.bala_portatil_noche || 0) + 
             parseInt(this.formData.regulador_ahorrador_noche || 0) + 
             parseInt(this.formData.paquete_pediatrico_noche || 0);
    },
    
    calcularTotalGeneral() {
      return this.calcularTotalDia() + this.calcularTotalNoche();
    },
    
    descargarPlantilla() {
      // Crear datos de ejemplo para la plantilla
      const datosEjemplo = [
        {
          'Fecha': '2026-02-03',
          'Regional': 'ANTIOQUIA- AREA METROPOLITANA',
          'Sede de Equipos': 'Sede Principal',
          'Observación': 'Ejemplo de disponibilidad de equipos',
          'Concentrador Bajo Flujo (Día)': 10,
          'Concentrador Bajo Flujo (Noche)': 8,
          'Concentrador Alto Flujo (Día)': 5,
          'Concentrador Alto Flujo (Noche)': 4,
          'Concentrador Portátil (Día)': 3,
          'Concentrador Portátil (Noche)': 2,
          'Aspirador (Día)': 15,
          'Aspirador (Noche)': 12,
          'Nebulizador (Día)': 20,
          'Nebulizador (Noche)': 18,
          'Oxímetro Adulto (Día)': 10,
          'Oxímetro Adulto (Noche)': 8,
          'Oxímetro Pediátrico (Día)': 5,
          'Oxímetro Pediátrico (Noche)': 4,
          'Bala Portátil (Día)': 12,
          'Bala Portátil (Noche)': 10,
          'Regulador Ahorrador (Día)': 8,
          'Regulador Ahorrador (Noche)': 6,
          'Paquete Pediátrico (Día)': 4,
          'Paquete Pediátrico (Noche)': 3
        },
        {
          'Fecha': '2026-02-04',
          'Regional': 'CENTRO',
          'Sede de Equipos': 'Sede Norte',
          'Observación': 'Actualización de inventario',
          'Concentrador Bajo Flujo (Día)': 8,
          'Concentrador Bajo Flujo (Noche)': 6,
          'Concentrador Alto Flujo (Día)': 4,
          'Concentrador Alto Flujo (Noche)': 3,
          'Concentrador Portátil (Día)': 2,
          'Concentrador Portátil (Noche)': 2,
          'Aspirador (Día)': 12,
          'Aspirador (Noche)': 10,
          'Nebulizador (Día)': 18,
          'Nebulizador (Noche)': 15,
          'Oxímetro Adulto (Día)': 8,
          'Oxímetro Adulto (Noche)': 6,
          'Oxímetro Pediátrico (Día)': 4,
          'Oxímetro Pediátrico (Noche)': 3,
          'Bala Portátil (Día)': 10,
          'Bala Portátil (Noche)': 8,
          'Regulador Ahorrador (Día)': 6,
          'Regulador Ahorrador (Noche)': 5,
          'Paquete Pediátrico (Día)': 3,
          'Paquete Pediátrico (Noche)': 2
        }
      ];
      
      try {
        // Crear workbook y worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(datosEjemplo);
        
        // Agregar hoja al workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Disponibilidad Equipos');
        
        // Generar archivo
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        // Crear enlace de descarga
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        const fecha = new Date();
        const nombreArchivo = `plantilla_disponibilidad_equipos_${fecha.getFullYear()}${(fecha.getMonth()+1).toString().padStart(2,'0')}${fecha.getDate().toString().padStart(2,'0')}.xlsx`;
        link.setAttribute('download', nombreArchivo);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        this.$bvToast.toast('Plantilla descargada exitosamente', {
          title: 'Éxito',
          variant: 'success',
          autoHideDelay: 3000
        });
      } catch (error) {
        console.error('Error descargando plantilla:', error);
        this.$bvToast.toast('Error al descargar la plantilla', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 3000
        });
      }
    },
    
    async cargarArchivoExcel(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      console.log('Archivo seleccionado:', file.name);
      
      // Validar tipo de archivo
      const extension = file.name.split('.').pop().toLowerCase();
      if (!['xlsx', 'xls', 'csv'].includes(extension)) {
        const mensaje = 'Por favor seleccione un archivo Excel válido (.xlsx, .xls o .csv)';
        this.$bvToast.toast(mensaje, {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 4000
        });
        alert(mensaje);
        event.target.value = '';
        return;
      }
      
      try {
        // Activar indicador de carga
        this.cargandoExcel = true;
        
        this.$bvToast.toast('Leyendo archivo...', {
          title: '📂 Procesando',
          variant: 'info',
          autoHideDelay: 2000
        });
        
        const data = await this.leerArchivoExcel(file);
        console.log('Datos leídos del Excel:', data);
        
        // Validar columnas de la plantilla
        if (!this.validarColumnasPlantilla(data)) {
          return; // El método ya muestra el error
        }
        
        this.$bvToast.toast('Validando datos...', {
          title: '🔍 Validando',
          variant: 'info',
          autoHideDelay: 2000
        });
        
        await this.procesarDatosExcel(data);
        
        // Limpiar input
        event.target.value = '';
      } catch (error) {
        console.error('Error cargando archivo:', error);
        const mensaje = 'Error al procesar el archivo Excel: ' + error.message;
        this.$bvToast.toast(mensaje, {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 4000
        });
        alert(mensaje);
        event.target.value = '';
      } finally {
        // Desactivar indicador de carga
        this.cargandoExcel = false;
      }
    },
    
    validarColumnasPlantilla(data) {
      if (!data || data.length === 0) {
        return true; // Se validará después
      }
      
      // Obtener las columnas del archivo
      const columnasArchivo = Object.keys(data[0]);
      console.log('Columnas en el archivo:', columnasArchivo);
      console.log('Columnas requeridas:', this.columnasRequeridas);
      
      // Validar que todas las columnas requeridas estén presentes
      const columnasFaltantes = [];
      const columnasIncorrectas = [];
      
      this.columnasRequeridas.forEach(columna => {
        if (!columnasArchivo.includes(columna)) {
          columnasFaltantes.push(columna);
        }
      });
      
      // Verificar si hay columnas que no coinciden (nombres modificados)
      columnasArchivo.forEach(columna => {
        if (!this.columnasRequeridas.includes(columna) && 
            columna !== 'Proveedor ID' && 
            columna !== 'ID Proveedor') {
          columnasIncorrectas.push(columna);
        }
      });
      
      if (columnasFaltantes.length > 0 || columnasIncorrectas.length > 0) {
        let mensaje = '❌ El archivo no coincide con la plantilla:\n\n';
        
        if (columnasFaltantes.length > 0) {
          mensaje += '📋 Columnas faltantes o con nombre incorrecto:\n';
          columnasFaltantes.forEach(col => {
            mensaje += `  • ${col}\n`;
          });
        }
        
        if (columnasIncorrectas.length > 0) {
          mensaje += '\n⚠️ Columnas con nombres incorrectos:\n';
          columnasIncorrectas.forEach(col => {
            mensaje += `  • ${col}\n`;
          });
        }
        
        mensaje += '\n💡 Por favor:\n';
        mensaje += '1. Descargue la plantilla usando el botón "Descargar Plantilla"\n';
        mensaje += '2. NO modifique los nombres de las columnas\n';
        mensaje += '3. Complete los datos según el formato de la plantilla\n';
        mensaje += '4. Guarde y cargue el archivo nuevamente';
        
        console.error('Error de validación de columnas:', {
          columnasFaltantes,
          columnasIncorrectas,
          columnasArchivo,
          columnasRequeridas: this.columnasRequeridas
        });
        
        this.$bvToast.toast(mensaje, {
          title: 'Error en Formato de Plantilla',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 15000,
          appendToast: false
        });
        
        alert(mensaje);
        
        return false;
      }
      
      console.log('✅ Validación de columnas exitosa');
      return true;
    },
    
    leerArchivoExcel(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            
            // Leer la primera hoja
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            
            // Convertir a JSON
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
            resolve(jsonData);
          } catch (error) {
            reject(error);
          }
        };
        
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
      });
    },
    
    async procesarDatosExcel(data) {
      console.log('Procesando datos Excel:', data);
      
      if (!data || data.length === 0) {
        const mensaje = 'El archivo está vacío o no tiene datos';
        this.$bvToast.toast(mensaje, {
          title: 'Advertencia',
          variant: 'warning',
          autoHideDelay: 3000
        });
        alert(mensaje);
        return;
      }
      
      console.log('Total de filas a procesar:', data.length);
      
      // Validar que haya un proveedor (para proveedores con id, permitir sin filtro para prestadores)
      let proveedorId = null;
      
      if (this.idProveedor) {
        // Usuario proveedor - usar su ID
        proveedorId = this.idProveedor;
        console.log('Usando proveedor del usuario:', proveedorId);
      } else if (this.filtroProveedor) {
        // Prestador con filtro de proveedor seleccionado
        proveedorId = this.filtroProveedor;
        console.log('Usando proveedor del filtro:', proveedorId);
      } else {
        // Si no hay proveedor, verificar si los datos del Excel incluyen proveedor
        if (!data[0]['Proveedor ID'] && !data[0]['ID Proveedor']) {
          const mensaje = 'Debe seleccionar un proveedor en el filtro o incluir "Proveedor ID" en el Excel';
          this.$bvToast.toast(mensaje, {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 5000
          });
          alert(mensaje);
          return;
        }
        console.log('Proveedor vendrá del Excel');
      }
      
      // Mapear las columnas del Excel a los campos de la base de datos
      const registrosValidos = [];
      const errores = [];
      
      data.forEach((row, index) => {
        const numeroFila = index + 2; // +2 porque empezamos en fila 2 (fila 1 es encabezado)
        
        try {
          // Validar campos requeridos
          if (!row['Fecha'] || !row['Regional'] || !row['Sede de Equipos']) {
            errores.push(`Fila ${numeroFila}: Faltan campos requeridos (Fecha, Regional o Sede de Equipos)`);
            return;
          }
          
          // Obtener ID de proveedor (del usuario, filtro o Excel)
          const proveedorRegistro = proveedorId || row['Proveedor ID'] || row['ID Proveedor'];
          
          if (!proveedorRegistro) {
            errores.push(`Fila ${numeroFila}: No se pudo determinar el proveedor`);
            return;
          }
          
          // Mapear los datos
          const registro = {
            fecha: this.formatearFechaExcel(row['Fecha']),
            proveedor: parseInt(proveedorRegistro),
            regional: row['Regional'],
            sede_de_equipos: row['Sede de Equipos'],
            observacion: row['Observación'] || '',
            conc_bajo_flujo_dia: parseInt(row['Concentrador Bajo Flujo (Día)'] || 0),
            conc_bajo_flujo_noche: parseInt(row['Concentrador Bajo Flujo (Noche)'] || 0),
            conc_alto_flujo_dia: parseInt(row['Concentrador Alto Flujo (Día)'] || 0),
            conc_alto_flujo_noche: parseInt(row['Concentrador Alto Flujo (Noche)'] || 0),
            conc_portatil_dia: parseInt(row['Concentrador Portátil (Día)'] || 0),
            conc_portatil_noche: parseInt(row['Concentrador Portátil (Noche)'] || 0),
            aspirador_dia: parseInt(row['Aspirador (Día)'] || 0),
            aspirador_noche: parseInt(row['Aspirador (Noche)'] || 0),
            nebulizador_dia: parseInt(row['Nebulizador (Día)'] || 0),
            nebulizador_noche: parseInt(row['Nebulizador (Noche)'] || 0),
            oximetro_adul_dia: parseInt(row['Oxímetro Adulto (Día)'] || 0),
            oximetro_adul_noche: parseInt(row['Oxímetro Adulto (Noche)'] || 0),
            oximetro_ped_dia: parseInt(row['Oxímetro Pediátrico (Día)'] || 0),
            oximetro_ped_noche: parseInt(row['Oxímetro Pediátrico (Noche)'] || 0),
            bala_portatil_dia: parseInt(row['Bala Portátil (Día)'] || 0),
            bala_portatil_noche: parseInt(row['Bala Portátil (Noche)'] || 0),
            regulador_ahorrador_dia: parseInt(row['Regulador Ahorrador (Día)'] || 0),
            regulador_ahorrador_noche: parseInt(row['Regulador Ahorrador (Noche)'] || 0),
            paquete_pediatrico_dia: parseInt(row['Paquete Pediátrico (Día)'] || 0),
            paquete_pediatrico_noche: parseInt(row['Paquete Pediátrico (Noche)'] || 0)
          };
          
          registrosValidos.push(registro);
        } catch (error) {
          errores.push(`Fila ${numeroFila}: Error al procesar datos - ${error.message}`);
        }
      });
      
      // Mostrar errores si los hay
      if (errores.length > 0) {
        console.error('Errores encontrados:', errores);
        
        // Crear mensaje de errores
        let mensajeErrores = `Se encontraron ${errores.length} errores:\n\n`;
        errores.slice(0, 10).forEach((error, idx) => {
          mensajeErrores += `${idx + 1}. ${error}\n`;
        });
        if (errores.length > 10) {
          mensajeErrores += `\n... y ${errores.length - 10} errores más. Ver consola para detalles.`;
        }
        
        // Mostrar toast persistente
        this.$bvToast.toast(mensajeErrores, {
          title: `⚠️ Errores de Validación (${errores.length})`,
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 10000,
          appendToast: false
        });
        
        // También mostrar alert nativo como fallback
        if (errores.length <= 5) {
          alert(mensajeErrores);
        }
      }
      
      // Si hay registros válidos, guardarlos
      if (registrosValidos.length > 0) {
        console.log('Registros válidos a guardar:', registrosValidos.length);
        await this.guardarDisponibilidadesMasivo(registrosValidos);
      } else {
        const mensaje = 'No se encontraron registros válidos para guardar. Revise los errores anteriores.';
        console.warn(mensaje);
        this.$bvToast.toast(mensaje, {
          title: 'Advertencia',
          variant: 'warning',
          autoHideDelay: 4000
        });
        alert(mensaje);
      }
    },
    
    formatearFechaExcel(fecha) {
      console.log('Formateando fecha:', fecha, 'Tipo:', typeof fecha);
      
      // Si es una fecha de Excel (número)
      if (typeof fecha === 'number') {
        // Excel guarda las fechas como días desde 1900-01-01
        // Ajustar por la zona horaria local para evitar el problema de -1 día
        const date = new Date((fecha - 25569) * 86400 * 1000);
        const anio = date.getUTCFullYear();
        const mes = String(date.getUTCMonth() + 1).padStart(2, '0');
        const dia = String(date.getUTCDate()).padStart(2, '0');
        const fechaFormateada = `${anio}-${mes}-${dia}`;
        console.log('Fecha numérica convertida:', fechaFormateada);
        return fechaFormateada;
      }
      
      // Si es string, intentar parsear
      if (typeof fecha === 'string') {
        // Si ya está en formato YYYY-MM-DD
        if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
          console.log('Fecha ya en formato correcto:', fecha);
          return fecha;
        }
        
        // Si está en formato DD/MM/YYYY
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
          const [dia, mes, anio] = fecha.split('/');
          const fechaFormateada = `${anio}-${mes}-${dia}`;
          console.log('Fecha DD/MM/YYYY convertida:', fechaFormateada);
          return fechaFormateada;
        }
        
        // Si está en formato MM/DD/YYYY (formato US)
        if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(fecha)) {
          const partes = fecha.split('/');
          const mes = partes[0].padStart(2, '0');
          const dia = partes[1].padStart(2, '0');
          const anio = partes[2];
          const fechaFormateada = `${anio}-${mes}-${dia}`;
          console.log('Fecha MM/DD/YYYY convertida:', fechaFormateada);
          return fechaFormateada;
        }
        
        // Intentar parsear con Date, pero usando UTC para evitar zona horaria
        try {
          // Crear fecha asumiendo formato local
          const date = new Date(fecha + 'T00:00:00');
          if (!isNaN(date.getTime())) {
            const anio = date.getFullYear();
            const mes = String(date.getMonth() + 1).padStart(2, '0');
            const dia = String(date.getDate()).padStart(2, '0');
            const fechaFormateada = `${anio}-${mes}-${dia}`;
            console.log('Fecha string parseada:', fechaFormateada);
            return fechaFormateada;
          }
        } catch (error) {
          console.error('Error parseando fecha string:', error);
        }
      }
      
      // Si es un objeto Date
      if (fecha instanceof Date && !isNaN(fecha.getTime())) {
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        const fechaFormateada = `${anio}-${mes}-${dia}`;
        console.log('Objeto Date convertido:', fechaFormateada);
        return fechaFormateada;
      }
      
      // Si no se pudo convertir, devolver la fecha actual
      console.warn('No se pudo convertir la fecha, usando fecha actual');
      const hoy = new Date();
      const anio = hoy.getFullYear();
      const mes = String(hoy.getMonth() + 1).padStart(2, '0');
      const dia = String(hoy.getDate()).padStart(2, '0');
      return `${anio}-${mes}-${dia}`;
    },
    
    async guardarDisponibilidadesMasivo(registros) {
      this.loading = true;
      
      try {
        const response = await disponibilidad.guardarDisponibilidadesMasivo({
          registros: registros
        });
        
        if (response && response.message) {
          const datos = response.message;
          const exitosos = datos.exitosos || 0;
          const fallidos = datos.fallidos || 0;
          const erroresBackend = datos.errores || [];
          
          // Mensaje de resultado
          if (exitosos > 0) {
            this.$bvToast.toast(
              `✓ Se guardaron ${exitosos} de ${registros.length} registros correctamente${fallidos > 0 ? '. ' + fallidos + ' registros fallaron.' : ''}`, 
              {
                title: 'Carga Masiva Completada',
                variant: exitosos === registros.length ? 'success' : 'warning',
                autoHideDelay: 5000
              }
            );
          } else {
            this.$bvToast.toast('No se pudo guardar ningún registro', {
              title: 'Error',
              variant: 'danger',
              autoHideDelay: 4000
            });
          }
          
          // Mostrar errores del backend si los hay
          if (erroresBackend.length > 0) {
            console.error('Errores del backend:', erroresBackend);
            
            let mensajeErrores = `❌ Errores al guardar (${fallidos} registros):\n\n`;
            erroresBackend.slice(0, 10).forEach((error, idx) => {
              mensajeErrores += `${idx + 1}. ${error}\n`;
            });
            if (erroresBackend.length > 10) {
              mensajeErrores += `\n... y ${erroresBackend.length - 10} errores más. Ver consola.`;
            }
            
            this.$bvToast.toast(mensajeErrores, {
              title: '❌ Errores al Guardar',
              variant: 'danger',
              solid: true,
              toaster: 'b-toaster-top-center',
              autoHideDelay: 10000,
              appendToast: false
            });
            
            // Alert nativo como fallback
            if (erroresBackend.length <= 5) {
              alert(mensajeErrores);
            }
          }
          
          // Recargar la tabla si hubo exitosos
          if (exitosos > 0) {
            this.consultarDisponibilidades();
          }
        } else {
          this.$bvToast.toast('Error al guardar los registros - Respuesta inválida del servidor', {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 4000
          });
        }
      } catch (error) {
        console.error('Error en guardado masivo:', error);
        this.$bvToast.toast(`Error al guardar los registros: ${error.message || 'Error desconocido'}`, {
          title: 'Error de Conexión',
          variant: 'danger',
          autoHideDelay: 5000
        });
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.panel-body {
  margin: 2% 5%;
  font-family: var(--font-family-poppins);
}

.descargarexcel {
  margin-bottom: 20px;
}

.botonexcel {
  background-color: var(--blue-violet) !important;
  border-color: var(--blue-violet) !important;
  border-radius: 10px;
  padding: 10px 20px;
  white-space: nowrap;
}

.botonexcel:hover {
  background-color: #6c3fb5 !important;
  border-color: #6c3fb5 !important;
}

.mr-2 {
  margin-right: 0.5rem;
}

.iconoexcel {
  margin-right: 5px;
}

.acciones {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.iconobuscar {
  font-size: 1rem;
}

.spinerr {
  text-align: center;
  padding: 50px;
}

.divnodata {
  text-align: center;
  padding: 50px;
}

.bannernodata {
  max-width: 300px;
  margin-bottom: 20px;
}

.nombrelabel {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 600;
}

.selectpage {
  border-radius: 5px;
}

.card-header {
  background-color: var(--blue-violet);
  color: white;
}

h5.text-primary {
  color: var(--blue-violet) !important;
  font-weight: 600;
}

.card.bg-light {
  background-color: #f8f9fa !important;
  border: 1px solid #dee2e6;
}

.card.bg-light .card-header {
  background-color: #e9ecef !important;
  color: #495057 !important;
  font-weight: 600;
}

.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}

.d-flex.gap-2 > * {
  margin-left: 0.5rem;
}

.d-flex.gap-2 > *:first-child {
  margin-left: 0;
}
</style>
